import useUserStore from '@/stores/userStore';

// Merchant Orders Pause: ops can stop an account putting NEW work into Boxy —
// creating an order by any door, and Ship Now — while every other capability
// keeps working (edit, cancel, resolve, resend, RTO, remittances, claims).
//
// The flag rides on GET /v1/user (`object.setting.orders_paused_at`), which
// App.tsx already pushes into userStore and usePermissionSync refetches, so a
// pause reaches the UI without a reload and without an extra request. Same
// synchronous seam usePermission and useBoxySelect use.
//
// ⭐ ABSENT MEANS ACCEPTING. Anything other than a real timestamp — the field
// being null, or missing entirely, which is what every backend that has not
// shipped the column sends — is "accepting orders", i.e. today's system. The
// dashboard must never infer a pause from a missing field, or a stale API
// would lock every merchant out of order creation.
//
// This is the UI half only. The backend refuses the eight intake routes on its
// own (middleware `merchant-accepts-orders`); hiding the buttons is courtesy,
// not enforcement, and a merchant who reaches the endpoint another way still
// gets a 400 with code 200008.
const useOrdersPaused = (): boolean =>
  useUserStore((state) => Boolean(state.user?.setting?.orders_paused_at));

export default useOrdersPaused;
